import { render, staticRenderFns } from "./YagiGacha.vue?vue&type=template&id=674773a2&scoped=true&"
import script from "./YagiGacha.vue?vue&type=script&lang=js&"
export * from "./YagiGacha.vue?vue&type=script&lang=js&"
import style0 from "./YagiGacha.vue?vue&type=style&index=0&id=674773a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674773a2",
  null
  
)

export default component.exports